/**
 * @author: @augustomna2010 
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Phone = (function () {

    function Phone() {

        Monet.UI.Fields.TextField.apply (this, arguments);

        var baseElement = null;

        this.createElement = function () {
            if(!baseElement){
                this.input = document.createElement('input');

                this.input.type = 'text';
                this.input.className = 'phoneField';
                this.input.value = this.value;

                if(this.maxSize){
                    this.input.maxLength = this.maxSize;
                }

                baseElement = this.input;
                this.rootEl.appendChild(this.input);
            }

        };

        this.dataIsInvalid = function () {
            if(this.input){
                this.value = this.input.value;
            }
            return !Monet.Validators.isPhone(this.value);
        };

        this.validations = function () {
            if(this.input){
                this.value = this.input.value;
            }

            if (this.dataIsInvalid()) {
                $(this.input).addClass('error');
            } else {
                $(this.input).removeClass('error');
            }

        };

        this.addEventListeners = function () {

            this.input.addEventListener('blur', (function (scope) {

                return function () {
                    scope.validations();
                };

            }(this)));

        };

        this.render = function () {

            this.createElement();
            this.addEventListeners();
            return this.rootEl;

        };

    }

    return Phone;

}());
